// Reglas de la grilla de servicios (home y /services), sin React ni imports,
// para que ~/fixo-scripts/rutas_servicios.js las pruebe tal cual (03-11-2026).

// El slug sale siempre de la base. Sin slug no hay ruta: deducirlo del título
// mandaba 4 rubros a /solicitar/otro (DEFECTO-VIVO-SERVICES-MANDA-A-OTRO).
export const rutaDeServicio = (s) => (s && s.slug ? `/solicitar/${s.slug}` : null);

// Sin slug el servicio no se muestra. El admin sí lo ve, marcado, porque
// POST /services no escribe slug y si no nadie se entera de que falta.
export const serviciosVisibles = (services, esAdmin) =>
  services.filter(s => s?.title && (esAdmin || s.slug));

// Los destacados en el orden de la lista, los primeros `cantidad`. Un slug
// que no está en la base se saltea.
export const serviciosDestacados = (services, slugs, cantidad) =>
  slugs.slice(0, cantidad)
    .map(slug => services.find(s => s.slug === slug))
    .filter(Boolean);

const normalizar = (t) => (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// El filtro corre EN EL NAVEGADOR (condición del 29-10-2026): el texto que se
// escribe no viaja al servidor. Lo declarado en Play depende de eso; si algún
// día pasa a GET /services?keyword=, hay que revisar la declaración antes.
export const filtrarServicios = (services, texto, categoria) => {
  const q = normalizar(texto.trim());
  return services.filter(s =>
    (!categoria || s.category === categoria) &&
    (!q || normalizar(s.title).includes(q) || normalizar(s.description).includes(q)));
};
